export default __webpack_public_path__ + "static/media/together.f8c7c5f9.png";